import { MainContainerWrapper, MainPadding } from "../../styles/Main.styles";
import { useState } from "react";
import TableFC, { TableFCBodyProps } from "../../components/table/Table";
import {
  useDeleteCategoryExpense,
  useGetListCategoryExpense,
} from "./network/resolver";
import TableHeader from "../../components/table/TableHeader";
import { ModalFC } from "../../components/modal/Modal";
import ExpenseCategoryForm from "./__components/Form";
import { IExpenseCategory } from "./ExpenseCategory.type";
import { Button, CircularProgress } from "@mui/material";
import { useParamUrl } from "../invoice/hooks/param/Param";

export default function ExpenseCategory() {
  const { getPage, setUrlPage } = useParamUrl();
  const [page, setPage] = useState(getPage());
  const [perPage, setPerPage] = useState(10);
  const { mutate: mutateDelete, isLoading: loadingDelete } =
    useDeleteCategoryExpense();
  const { data: dataRawListCategoryExpense, isLoading: loadingFetch } =
    useGetListCategoryExpense({
      page,
      perPage,
    });
  const dataListCategoryExpense = dataRawListCategoryExpense?.data?.data?.data;
  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState<IExpenseCategory | undefined>(
    undefined
  );
  const [toDeleteId, setToDeleteId] = useState(0);
  const header = ["No", "Nama", ""];
  const bodyTable: TableFCBodyProps[] = [
    { key: "name" },
    {
      key: "",
      newComponent: (item) => {
        setToDeleteId(item.id);
        return loadingDelete && toDeleteId === item.id ? (
          <CircularProgress size={20} />
        ) : (
          <Button
            onClick={() => mutateDelete({ expense_category_id: item.id })}
            color="error"
            variant="contained"
            size="small"
          >
            Hapus
          </Button>
        );
      },
    },
  ];

  return (
    <MainPadding>
      <MainContainerWrapper>
        <TableHeader
          title="Kategori Expense"
          addButton
          onClickAdd={() => {
            setShowModal(true);
            setSelected(undefined);
          }}
        />
        <TableFC
          showIndex
          loading={loadingFetch}
          data={dataListCategoryExpense}
          head={header}
          body={bodyTable}
          totalRows={dataRawListCategoryExpense?.data?.data?.total}
          onPerPageChange={(e) => setPerPage(e)}
          onPageChange={(e) => {
            setUrlPage(e);
            setPage(e);
          }}
          onCellClick={(e) => {
            setSelected(e);
            setShowModal(true);
          }}
        />
      </MainContainerWrapper>
      <ModalFC
        open={showModal}
        onClose={() => {
          setShowModal(false);
          setSelected(undefined);
        }}
      >
        <ExpenseCategoryForm id={selected?.id} />
      </ModalFC>
    </MainPadding>
  );
}
